/**
 * Implementation of Suggestion for profile-based AI matching.
 * Extends SuggestionSchema with type-specific fields and literal discriminator.
 */

import { z } from "zod";
import { SuggestionSchema } from "./suggestion.schemas.js";
import { LocalizedTextSchema } from "./localized-text.schemas.js";
import type { Suggestion } from "./suggestion.schemas.js";

export const profileBasedSuggestionSchema = SuggestionSchema.extend({
  suggestionType: z.literal("profile_based"),
  // The engine's why-connect prose, and REQUIRED: a suggestion with no reason to act on
  // it is not a suggestion, so a candidate without one is dropped at the fold rather
  // than offered bare (PLA-1359).
  whyConnect: LocalizedTextSchema,
});

export type ProfileBasedSuggestion = z.infer<
  typeof profileBasedSuggestionSchema
>;

export function isProfileBasedSuggestion(
  suggestion: Suggestion,
): suggestion is ProfileBasedSuggestion {
  return suggestion.suggestionType === "profile_based";
}
